import { useMutation } from '@tanstack/react-query';
import { fetchQuickPeekCulturalSocial } from '@/services/travelAssistantService';
import type { QuickPeekRequest } from '@/services/api/interfaces/ITravelAssistantRepository';

/**
 * Custom hook for fetching cultural and social information
 * Single Responsibility: Handles only cultural/social data fetching
 * Dependency Inversion: Depends on service abstraction (fetchQuickPeekCulturalSocial)
 *
 * @param accessToken - Optional access token for authentication
 * @param refreshToken - Optional refresh token for authentication
 * @returns Mutation object with mutate function and state
 */
export function useCulturalSocial(accessToken?: string, refreshToken?: string) {
  return useMutation({
    mutationFn: async ({
      request,
      signal,
    }: {
      request: QuickPeekRequest;
      signal?: AbortSignal;
    }) => {
      return fetchQuickPeekCulturalSocial(
        request,
        accessToken,
        refreshToken,
        signal
      );
    },
    onError: error => {
      console.error(
        '[useCulturalSocial] Error fetching cultural social data:',
        error
      );
    },
  });
}
